import { makeStyles } from '@material-ui/core'
import { DateRange, ScheduleType } from 'elements/scheduleDialog/types'
import { translateMatches, translateTimeLabel } from 'elements/scheduleDialog/utils'
import { FC } from 'react'
import { useTranslate } from 'react-admin'
import { Theme } from 'types/themes'
import { dayNames, monthNames } from 'util/misc'

const useStyles = makeStyles((theme: Theme) => ({
  dateRangeBlock: {
    marginBottom: 12,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  dateRangeLine: {
    marginBottom: 4,
    fontWeight: 500,
  },
  weekdayLabel: {
    marginTop: 6,
    marginBottom: 2,
    fontSize: '0.9em',
  },
  timeRangeLine: {
    paddingLeft: 12,
    fontSize: '0.9em',
    color: theme.greyMid1 || 'rgba(0,0,0,0.6)',
  },
}))

const formatDateRangeLine = (range: DateRange, translate: (s: string) => string) => {
  if (!range.start_date || !range.end_date) return null
  const startDate = `${range.start_date.getDate()} ${translate(monthNames[range.start_date.getMonth()])}`
  const endDate = `${range.end_date.getDate()} ${translate(monthNames[range.end_date.getMonth()])}`
  return `${startDate} to ${endDate}`
}

const formatAllDateRanges = (value: ScheduleType, translate: (s: string) => string) => {
  const validDateRanges = value?.date_ranges?.filter((r) => r?.start_date && r?.end_date) || []
  if (validDateRanges.length === 0) return '-'
  return validDateRanges.map((r) => formatDateRangeLine(r, translate)).filter(Boolean).join(', ')
}

type Props = {
  value: ScheduleType
  groupedSchedules: Record<string, string[]>
  schedulesLength: number
}

const StackedSchedule: FC<Props> = ({ value, groupedSchedules, schedulesLength }) => {
  const classes = useStyles()
  const translate = useTranslate()
  const dateLine = formatAllDateRanges(value, translate)

  return (
    <div className={classes.dateRangeBlock}>
      <div className={classes.dateRangeLine}>{dateLine}</div>
      {!!schedulesLength &&
        Object.keys(groupedSchedules).map((weekdayLabel) => (
          <div key={weekdayLabel} className="timeWrapper">
            <div className={classes.weekdayLabel}>
              {translateMatches({ inputTerm: weekdayLabel, matchesToTranslate: dayNames, translate })}
            </div>
            {groupedSchedules[weekdayLabel].map((timeRange, i) => (
              <div key={i} className={classes.timeRangeLine}>
                {timeRange === 'All Hours' ? translate('All Hours') : translateTimeLabel(timeRange, translate)}
              </div>
            ))}
          </div>
        ))}
    </div>
  )
}

export default StackedSchedule
